var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Checkbox, FormControlLabel, IconButton, TextField, Tooltip } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { TelegramTargetEntityType } from 'common/enums/telegram/telegram-target-entity-type.enum';
import { UPDATE_TELEGRAM_CHAT_INFO } from 'common/graphql/mutations/telegram/update-telegram-chat-info';
import { SPORT_CLUB_TELEGRAM_SETTINGS } from 'common/graphql/queries/sportClub/sportClubTelegramSettings';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
import history from 'store/history';
var SportClubTelegramSettingsInviteLinkSettings = function (_a) {
    var sportClub = _a.sportClub;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _b = useState(false), isEditMode = _b[0], setIsEditMode = _b[1];
    var _c = useState(false), openCopyTextButtonTooltip = _c[0], setOpenCopyTextButtonTooltip = _c[1];
    var _d = useState(false), openRefreshTextButtonTooltip = _d[0], setOpenRefreshTextButtonTooltip = _d[1];
    var onSportClubJoinLinkCopy = function () {
        dispatch(openSnackbar({
            message: t('Ссылка-приглашение успешно скопирована.'),
            severity: SnackbarSeverity.SUCCESS
        }));
    };
    var onError = function (_a) {
        var code = _a.code, errorDetails = _a.errorDetails;
        var isForbidden = code.includes('forbidden');
        var text = isForbidden
            ? t('У вас нет прав на управление этим клубом')
            : t('Произошла ошибка, обратитесь в поддержку. Ошибка: ') + code;
        dispatch(openSnackbar({
            message: text,
            severity: SnackbarSeverity.ERROR
        }));
        if (isForbidden)
            history.push((sportClub === null || sportClub === void 0 ? void 0 : sportClub.url) ? "/club/".concat(sportClub === null || sportClub === void 0 ? void 0 : sportClub.url) : '/clubs');
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t('Данные сохранены'),
            severity: SnackbarSeverity.SUCCESS
        }));
        setIsEditMode(false);
    };
    var updateSportClub = function (data) {
        return useMutation(UPDATE_TELEGRAM_CHAT_INFO, {
            variables: __assign({ entityId: sportClub.id, entityType: TelegramTargetEntityType.SportClub }, data),
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: SPORT_CLUB_TELEGRAM_SETTINGS,
                    variables: {
                        id: sportClub.id
                    }
                },
            ]
        });
    };
    var handleExecuteMutation = useDynamicMutation(updateSportClub, onSuccess, onError).handleExecuteMutation;
    var handleSubmit = function (values) {
        handleExecuteMutation(__assign(__assign({}, values), { telegramChatInviteLink: values.telegramChatInviteLink === '' ? null : values.telegramChatInviteLink }));
    };
    var handleRefresh = function () {
        handleExecuteMutation({ isExportNewTelegramChatInviteLink: true });
    };
    var defaultFormState = {
        telegramChatInviteLink: sportClub.chatInfo.telegramChatInviteLink,
        isShowTelegramChatInviteLink: sportClub.chatInfo.isShowTelegramChatInviteLink
    };
    var formik = useFormik({
        enableReinitialize: true,
        initialValues: __assign({}, defaultFormState),
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined);
        formik.handleChange(e);
    };
    var handleReset = function () {
        setIsEditMode(false);
        formik.resetForm();
    };
    return (_jsx("div", __assign({ className: "flex flex-col  w-full pt-20" }, { children: _jsxs("form", __assign({ className: "flex flex-col space-y-20 xs:max-w-320 md:max-w-640", onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsx("div", __assign({ className: "max-w-288" }, { children: isEditMode ? (_jsxs("div", __assign({ className: "flex flex-row space-x-10" }, { children: [_jsx(Button, __assign({ type: "reset", color: "secondary", onClick: function () { return handleReset(); } }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)) : (_jsx(Button, __assign({ type: "button", onClick: function () { return setIsEditMode(!isEditMode); } }, { children: t('Редактировать') }), void 0)) }), void 0), _jsxs("div", __assign({ className: "flex flex-row space-x-10 items-center" }, { children: [_jsx(TextField, { disabled: !isEditMode, label: t('Ссылка-приглашение в телеграм группу'), name: "telegramChatInviteLink", value: formik.values['telegramChatInviteLink'], onChange: handleChangeWrapper, error: Boolean(formik.errors['telegramChatInviteLink']), helperText: formik.errors['telegramChatInviteLink'], className: "w-240" }, void 0), _jsx(Tooltip, __assign({ onMouseOver: function () { return setOpenRefreshTextButtonTooltip(true); }, onMouseLeave: function () { return setOpenRefreshTextButtonTooltip(false); }, onClose: function () { return setOpenRefreshTextButtonTooltip(false); }, open: openRefreshTextButtonTooltip, title: t('Обновить') }, { children: _jsx(IconButton, __assign({ onClick: handleRefresh }, { children: _jsx(RefreshIcon, { className: "w-24 h-24 cursor-pointer", color: "primary" }, void 0) }), void 0) }), void 0), sportClub.chatInfo.telegramChatInviteLink !== undefined && (_jsx(Tooltip, __assign({ onMouseOver: function () { return setOpenCopyTextButtonTooltip(true); }, onMouseLeave: function () { return setOpenCopyTextButtonTooltip(false); }, onClose: function () { return setOpenCopyTextButtonTooltip(false); }, open: openCopyTextButtonTooltip, title: t('Скопировать') }, { children: _jsx(IconButton, __assign({ onClick: function () {
                                    navigator.clipboard.writeText(sportClub.chatInfo.telegramChatInviteLink);
                                    onSportClubJoinLinkCopy();
                                } }, { children: _jsx(ContentCopyIcon, { className: "w-20 h-20 cursor-pointer", color: "primary" }, void 0) }), void 0) }), void 0))] }), void 0), _jsx(FormControlLabel, { className: "xs:w-140 md:w-240", disabled: !isEditMode, control: _jsx(Checkbox, { checked: formik.values['isShowTelegramChatInviteLink'] || false, onChange: function (e) {
                            formik.setFieldError('isShowTelegramChatInviteLink', undefined);
                            formik.setFieldValue('isShowTelegramChatInviteLink', e.target.checked);
                        } }, void 0), label: t('Ссылка видна на странице сообщества') }, void 0)] }), void 0) }), void 0));
};
export default SportClubTelegramSettingsInviteLinkSettings;
